// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as ButtonCmp$PorterinFeature from "./ButtonCmp.mjs";
import * as ButtonCmpModuleScss from "../styles/ButtonCmp.module.scss";

var styles = ButtonCmpModuleScss;

function SecondaryButtonCmp(Props) {
  var on_click = Props.on_click;
  var children = Props.children;
  return React.createElement(ButtonCmp$PorterinFeature.make, {
              on_click: on_click,
              class_name: styles["secondary-button"],
              children: children
            });
}

var make = SecondaryButtonCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
